import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@material-ui/core'
import cls from 'classnames'
import { useEffect } from 'react'
import { Controller, FieldErrors } from 'react-hook-form'

import { AllNewReportForm } from '../../new-report-form-schema'
import { useNewReportForm } from '../../use-new-report-form'
import { useStyles } from './styles'

export function CultureSelectorInput() {
  const classes = useStyles()
  const { control, formState, register, setValue, watch } = useNewReportForm()
  const [cane, soybean] = watch(['cane', 'soybean'])

  const errors = formState.errors as FieldErrors<AllNewReportForm>

  function selectCorrectCulture() {
    const options = [
      {
        value: 'all',
        isValid: cane && soybean,
      },
      {
        value: 'cane',
        isValid: cane && !soybean,
      },
      {
        value: 'soybean',
        isValid: !cane && soybean,
      },
    ]

    setValue(
      'culture',
      options.find((option) => option.isValid)?.value ?? ('' as any),
    )
  }

  useEffect(() => {
    selectCorrectCulture()
  }, [cane, soybean])

  useEffect(() => {
    register('culture')
  }, [])

  return (
    <>
      <Box
        className={
          errors.culture
            ? cls(classes.formGroup, classes.borderError)
            : cls(classes.formGroup, classes.border)
        }
      >
        <Typography variant='body1'>Selecione as culturas:</Typography>
        <Typography variant='subtitle2'>
          O relatório de cada cultura será enviado separadamente.
        </Typography>
        <FormGroup row>
          <Controller
            control={control}
            name='cane'
            defaultValue={false}
            render={({ field: { value, onChange, name } }) => (
              <FormControlLabel
                name={name}
                control={
                  <Checkbox
                    size='small'
                    data-testid='cana'
                    checked={value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                }
                label={
                  <Typography variant='subtitle1'>Cana-de-açúcar</Typography>
                }
              />
            )}
          />
          <Controller
            control={control}
            name='soybean'
            defaultValue={false}
            render={({ field: { value, onChange, name } }) => (
              <FormControlLabel
                name={name}
                control={
                  <Checkbox
                    size='small'
                    data-testid='soja'
                    checked={value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                }
                label={<Typography variant='subtitle1'>Soja</Typography>}
              />
            )}
          />
        </FormGroup>
      </Box>
      {errors.culture && (
        <Typography variant='subtitle2' className={classes.errorMessage}>
          * {errors.culture.message}
        </Typography>
      )}
    </>
  )
}
